/** Contact identifiers are lists (several phones/emails per contact) — the
 * first value as text; '' when none. Also accepts a plain string. */
export const firstText = (value: unknown): string => {
  const v = Array.isArray(value) ? value.find((x) => x != null && x !== '') : value;
  return v == null ? '' : String(v);
};
